import { createClient } from "@cargoticcom/api-client";

import Axios from "axios";

import config from "./config";

const axios = Axios.create({
  baseURL: config.api.urlV1,
  withCredentials: true,
  headers: {
    "X-Cargotic-API-Client": "Cargotic Webapp API Client"
  }
});

const client = createClient(axios);

export default client;
export { axios };
